import { render, staticRenderFns } from "./performance-analysis.vue?vue&type=template&id=1bcf9b78&scoped=true"
import script from "./performance-analysis.vue?vue&type=script&lang=js"
export * from "./performance-analysis.vue?vue&type=script&lang=js"
import style0 from "./performance-analysis.vue?vue&type=style&index=0&id=1bcf9b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf9b78",
  null
  
)

export default component.exports